import type { ShopRoutingLocationRuleDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

export default function useAddOneShopRoutingLocationRules(shopId: string) {
	return useApiMutation("post", "/shops/{shopId}/routing-location-rules", {
		invalidate: useInvalidateShop(shopId),
		mapVariables: (requestBody: ShopRoutingLocationRuleDto) => ({
			params: { path: { shopId } },
			body: requestBody,
		}),
	});
}
